import { render, staticRenderFns } from "./ImageVariant.vue?vue&type=template&id=670ff8ae"
import script from "./ImageVariant.vue?vue&type=script&lang=js"
export * from "./ImageVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports